"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.addUnit = exports.UA = void 0;
exports.camelize = camelize;
exports.checkSdkSupport = void 0;
exports.compareVersion = compareVersion;
exports.get = get;
exports.isAndroid = exports.getParam = void 0;
exports.isDef = isDef;
exports.isFunction = isFunction;
exports.isIOS = void 0;
exports.isInDocument = isInDocument;
exports.isInViewPort = isInViewPort;
exports.isMp = void 0;
exports.isObj = isObj;
exports.isObject = isObject;
exports.isPromise = isPromise;
exports.isiPhoneX = exports.isZLJNew = exports.isWechat = exports.isServer = void 0;
exports.noop = noop;
exports.padZero = padZero;
exports.px2rem = px2rem;
exports.range = range;
exports.setTransition = exports.setTransform = void 0;
exports.suffixPx = suffixPx;
exports.suffixRem = suffixRem;
exports.use = exports.ua = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.parse-float.js");
require("core-js/modules/es.regexp.constructor.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.parse-int.js");
require("core-js/modules/es.string.match.js");
var _vue = _interopRequireDefault(require("vue"));
var _number = require("./validate/number");
var _use = require("./use");
exports.use = _use.use;
var _unit = require("./format/unit");
exports.addUnit = _unit.addUnit;
var camelizeRE = /-(\w)/g;
var isServer = _vue.default.prototype.$isServer;
exports.isServer = isServer;
var isMp = !isServer && !window && !navigator;
exports.isMp = isMp;
var UA = isServer || isMp ? '' : navigator.userAgent.toLowerCase();
exports.UA = UA;
var ua = isServer || isMp ? '' : navigator.userAgent;
exports.ua = ua;
var isZLJNew = /zhaoliangji-v2/ig.test(UA);
exports.isZLJNew = isZLJNew;
function noop() {}
function isDef(value) {
  return value !== undefined && value !== null;
}
function isObj(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}
function get(object, path) {
  var keys = path.split('.');
  var result = object;
  keys.forEach(function (key) {
    result = isDef(result[key]) ? result[key] : '';
  });
  return result;
}
function camelize(str) {
  return str.replace(camelizeRE, function (_, c) {
    return c.toUpperCase();
  });
}
function range(num, min, max) {
  return Math.min(Math.max(num, min), max);
}
function isInDocument(element) {
  return isServer ? false : document.body.contains(element);
}
function px2rem(value) {
  if (isServer) return 0;
  var rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
  var ratio = window.innerWidth / 750;
  return +value * ratio / rootFontSize;
}
function suffixPx(value) {
  if (!isDef(value)) {
    return undefined;
  }
  value = String(value);
  return (0, _number.isNumber)(value) ? value + "px" : value;
}
function suffixRem(value) {
  if (!isDef(value)) {
    return undefined;
  }
  value = String(value);
  return (0, _number.isNumber)(value) ? px2rem(value) + "rem" : value;
}
function padZero(num) {
  return (num < 10 ? '0' : '') + num;
}

/*
 * transition添加浏览器前缀
 */
var setTransition = function setTransition(ele, val) {
  if (!ele) return;
  ele.style.transition = val;
  ele.style.WebkitTransition = '-webkit-' + val;
  ele.style.MozTransition = '-moz-' + val;
  ele.style.OTransition = '-o-' + val;
};

/*
 * transform添加浏览器前缀
 */
exports.setTransition = setTransition;
var setTransform = function setTransform(ele, val) {
  if (!ele) return;
  ele.style.transform = val;
  ele.style.WebkitTransform = val;
  ele.style.MozTransform = val;
  ele.style.OTransform = val;
};
exports.setTransform = setTransform;
var getParam = function getParam(url, paramName) {
  var obj = {};
  var reg = /(\w+)=(\w+)/g;
  while (reg.exec(url)) {
    obj[RegExp.$1] = RegExp.$2;
  }
  return obj[paramName] ? obj[paramName] : 0;
};
exports.getParam = getParam;
var isAndroid = function () {
  return /android/.test(UA);
}();
exports.isAndroid = isAndroid;
var isIOS = function () {
  return /ios|iphone|ipad|ipod/.test(UA);
}();
exports.isIOS = isIOS;
var isWechat = function () {
  return /micromessenger/.test(UA);
}();
exports.isWechat = isWechat;
var isiPhoneX = function () {
  if (!isIOS) return false;
  var _window$screen = window.screen,
    width = _window$screen.width,
    height = _window$screen.height;
  var isiPhoneXs = window.devicePixelRatio === 3 && width === 375 && height === 812;
  var isiPhoneXsMax = window.devicePixelRatio === 3 && width === 414 && height === 896;
  var isiPhoneXr = window.devicePixelRatio === 2 && width === 414 && height === 896;
  var isiPhone12 = window.devicePixelRatio === 3 && width === 390 && height === 844;
  var isiPhone12Max = window.devicePixelRatio === 3 && width === 428 && height === 926;
  var isiPhone14Pro = window.devicePixelRatio === 3 && width === 393 && height === 852;
  var isiPhone14ProMax = window.devicePixelRatio === 3 && width === 430 && height === 932;
  return isiPhoneXs || isiPhoneXsMax || isiPhoneXr || isiPhone12 || isiPhone12Max || isiPhone14Pro || isiPhone14ProMax;
}();
exports.isiPhoneX = isiPhoneX;
function isInViewPort(element) {
  var viewWidth = window.innerWidth || document.documentElement.clientWidth;
  var _element$getBoundingC = element.getBoundingClientRect(),
    left = _element$getBoundingC.left,
    right = _element$getBoundingC.right;
  return left >= -20 && right <= viewWidth + 20 // 部分小米机型下的react获取的right值有些许偏差
  ;
}

function isObject(val) {
  return val !== null && typeof val === 'object';
}
function isFunction(val) {
  return typeof val === 'function';
}
function isPromise(val) {
  return isObject(val) && isFunction(val.then) && isFunction(val.catch);
}
function compareVersion(v1, v2) {
  var seq1 = v1.split('.').map(function (subVersion) {
    return parseInt(subVersion, 10);
  });
  var seq2 = v2.split('.').map(function (subVersion) {
    return parseInt(subVersion, 10);
  });
  var len1 = seq1.length;
  var len2 = seq2.length;
  var commonLen = Math.min(len1, len2);
  for (var i = 0; i < commonLen; ++i) {
    if (seq1[i] !== seq2[i]) {
      return seq1[i] < seq2[i] ? -1 : 1;
    }
  }
  return len1 === len2 ? 0 : len1 < len2 ? -1 : 1;
}
var checkSdkSupport = function checkSdkSupport(version) {
  var zzVersion = ua.match(/zzVersion\/(\S*) zzT/);
  if (zzVersion && Array.isArray(zzVersion) && compareVersion(zzVersion[1], version) > -1) {
    return true;
  }
  return false;
};
exports.checkSdkSupport = checkSdkSupport;